export default {
    methods: {
        get(key = null, options = {}) {
            return axios({
                method: 'get',
                url: route('api.session.get'),
                params: {
                    key: key
                }
            })
            .then(response => {
                if(response.data.success) {
                    if(key) {
                        this.$set(this.$state.session, key, response.data.data)
                    } else {
                        this.$set(this.$state, 'session', response.data.data)
                    }

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        put(key, value, options = {}) {
            return axios({
                method: 'put',
                url: route('api.session.put'),
                data: {
                    key: key,
                    value: value
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        //  Pushing To Array Session Values
        push(key, value, options = {}) {
            return axios({
                method: 'post',
                url: route('api.session.push'),
                data: {
                    key: key,
                    value: value
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        //  Retrieving & Deleting An Item
        pull(key, options = {}) {
            return axios({
                method: 'patch',
                url: route('api.session.pull'),
                data: {
                    key: key
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        increment(key, value, options = {}) {
            return axios({
                method: 'patch',
                url: route('api.session.increment'),
                data: {
                    key: key,
                    value: value
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        decrement(key, value, options = {}) {
            return axios({
                method: 'patch',
                url: route('api.session.decrement'),
                data: {
                    key: key,
                    value: value
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        },

        forget(key, options = {}) {
            return axios({
                method: 'delete',
                url: route('api.session.forget'),
                data: {
                    key: key
                }
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this.$state, 'session', response.data.data)

                    return response.data.data
                }

                return Promise.reject(response.data)
            })
            .catch(error => this.$Util.getMessageFromError(error))
        }
    }
}